<!-- eslint-disable -->
<template>
	<b-container class="text-12 text-gotham-medium w-50 m-width text-14 container mb-4">
		<PaxelLoader :loading="loadingIcon" style="
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);">
		</PaxelLoader>
		<div v-if="!loadingIcon"> 
			<div class="shadow-sm px-4 py-3 mx-2 rounded">
				<div class="d-flex justify-content-between">
					<div class="text-gotham align-self-center">Status</div>
					<div
						class="align-self-center text-gotham-bold"
						:style="`font-size:14px;color:${displayStatus.color};`"
					>
						{{ displayStatus.text }}
					</div>
				</div>
			</div>

			<div class="pt-4"  v-if="status == 'IN_STORE'"> 
				<div class="text-center">
					<label class="text-gotham" style="font-size: 14px">{{ language == 'en' ? 'Door Number' : 'Nomor Pintu' }} :</label>
					<div class="door-number text-gotham-bold"> {{ doorNumber }}</div>
				</div>
				<div class="py-4" style="justify-content:center;display: flex;margin: auto;">
						<Qrcode :value="qrCode" :isBase64="false"/>
				</div>
			</div>

			<!-- Attention-->
			<div class="mx-2 mt-4" style="
				border-radius: 6px;
				border:2px solid #FFB003;
				background-color: #FAFAFA;" v-if="status == 'IN_STORE' && attention">
				<div class="px-4 py-2">
					<div class="text-center text-gotham-bold pb-2" style="color: #FF434F;font-size: 16px;line-height: 20px;">{{ language == 'en' ? attention.title : attention.title_bahasa }} </div>
					<div class="html-wrapper" style="line-height: 20px;" v-html="language == 'en' ? attention.description : attention.description_bahasa"></div>
				</div>
			</div>

			<div class="divider mt-4" v-if="status == 'IN_STORE'"></div>

			<InfoList class="my-4" :title="language == 'en' ? 'Drop Off Info' : 'Info Drop Off'" :data="rentInfo" cta="order_dropoffinfo_copy_order_number" />

			<div class="divider my-4" v-if="status == 'IN_STORE'"></div>
			
			<Collapsible
				v-if="status == 'IN_STORE'"
				id="howto"
				cta="order_howto_toggle"
				:title="
					language == 'en' ? howToStep.title : howToStep.title_bahasa
				"
				:open="toogleHowto"
				@onClick="toogleHowto = !toogleHowto"
			>
				<HowTo :content="instruction" />
			</Collapsible>

			<div class="divider my-4"></div>

			<Collapsible
				id="info"
				cta="order_lokasi_toggle"
				:title="language == 'en' ? 'PaxelBox Location Info' : 'Info Lokasi PaxelBox'"
				:open="toogleInfo"
				@onClick="toogleInfo = !toogleInfo"
			>
				<div class="">
					<div class="">
						<div class="py-2 text-gotham-bold" style="font-size: 16px;">
							{{ addressMain || "-" }}
						</div>
						<div class="text-gotham text-left" style="font-size: 12px;line-height: 16px;">
							{{ addressDetail || "-" }}
						</div>
						<div class="py-2 " v-if="lat && long">
							<span
								data-cta="order_lokasi_lihat_peta"
								@click="openMapLink"
								class="text-purple text-gotham-bold text-left"
								style="font-size: 12px;line-height: 16px;color: #5e51a1;"
								>{{ language == "en" ? "See map" : "Lihat peta" }} >
							</span>
						</div>
						<div class="py-2 text-gotham text-left" style="font-size: 12px;line-height: 16px;">
							{{ addressAdditionalDetail || "-" }}
						</div>
						<div
							class="py-2 text-gotham text-left"
							style="font-size: 12px;line-height: 16px;white-space:pre-wrap"
						>
							<div>{{ language == "en" ? "Operational Hours" : "Jam Operasional" }} :</div>
							<div class="mt-2">{{ operationalHour || "-" }}</div>
						</div>
						<div class="row px-3">
							<div class="" style="height: 160px;width: 50%;max-width: 200px;">
								<img
									v-if="locker_photo"
									:src="locker_photo"
									class="image-fit"
									data-cta="order_lokasi_foto_locker"
									@click="show(locker_photo)"
									@error="imageUrlNoContent"
									alt="Locker"
								/>
							</div>
						</div>
					</div>
				</div>
			</Collapsible>
			
			<div class="divider my-4"></div>

			<div class="text-center mx-6 pb-4">
				<button
					v-if="yellowai == 'enabled'"
					class="button rounded-lg py-3 text-gotham-bold"
					style="width: 90%;background-color: white;border: 1px solid #5e51a1;color:#5e51a1;position:relative"
					data-cta="order_hera"
					@click="buttonContactSupport()"
				>
					{{ language == "en" ? "Need help? Contact HERA" : "Butuh bantuan? Hubungi HERA" }}
					<img src="@/assets/images/hera.svg" alt="hera" class="icon-hera-button">
				</button>
			</div>
		</div>

	</b-container>
</template>
<script>
/* eslint-disable */

import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
import i18n from '@/plugins/i18n';
import PaxelLoader from '@/components/PaxelLoader.vue';
import InfoList from "@/views/mobile/order/status/components/InfoList.vue";
import Collapsible from "@/views/mobile/order/status/components/Collapsible.vue";
import HowTo from "@/views/mobile/order/status/components/HowTo.vue";
import Qrcode from "@/views/mobile/order/status/components/Qrcode.vue";


Vue.use(VueViewer);
export default {
	components: { PaxelLoader,InfoList,Collapsible,HowTo,Qrcode },
  data() {
    return {
      pakpoboxAPIUrl: process.env.VUE_APP_PAKPOBOX_API,
      heraUrl: process.env.VUE_APP_HERA_LINK,
      addressMain: '',
      addressDetail: '',
      addressAdditionalDetail: '',
      mapUrl: '',
      operationalHour: '',
      locker_photo: '',
      lat: '',
      long: '',
      qrImage: '',
      doorNumber: '',
      status: '',
      deadlineDate: '',
      storeTime: '',
      takeTime: '',
      orderNumber: '',
      qrCode: '',
      images: [],
			loadingIcon: true,
			yellowai:"",
			toogleInfo:true,
			toogleHowto:true,
			boxLocationDetail:null,
			howToStep : {
				description:"",
				description_bahasa:"",
				title:"",
				title_bahasa:"",
				value:"",
			},
			instruction:"",
			attention:"",
			counterCheck:null,
    };
  },
	async mounted(){
		let settings = this.$store.getters.getSettings;
		if(!settings){
			await this.$store.dispatch("getSettings")
		}
		this.howToStep = this.getPaxelBoxContentSetting("how_to_pick_up_dropoff")
		this.attention = this.getPaxelBoxContentSetting("attention_pick_up_dropoff")
		
		this.instruction = this.howToStep.description_bahasa?.replaceAll("{{door_number}}", this.doorNumber);
		if(this.language == 'en'){
			this.instruction = this.howToStep.description?.replaceAll("{{door_number}}", this.doorNumber);
		}
	},
  beforeMount() {
		//this function is for replacement computed on vue, because value call on vanila js not vue
		window.addEventListener('yellowai-key-localstorage-changed', (event) => {
			this.yellowai = event.detail.storage;
		});
		
		this.yellowai = localStorage.getItem('yellowai')
		this.validateUser()
    // checking query paramater order
    const paramOrderId = this.$route.query.orderid;
    if (paramOrderId !== undefined) {
			this.loadingIcon = true;
      this.$store.dispatch('getOrderDetail', paramOrderId)
        .then((res) => {
					//check is overdue or not 
					this.counterCheck = setInterval(() => {
						this.checkIsOverdue(paramOrderId , new Date().getTime(), res.overdueTime, res.overduePrice);
						this.loadingIcon = false;
					}, 1 * 1000);
					
					this.orderNumber = res.expressNumber;
					this.doorNumber = res.mouth.number;
					this.deadlineDate = res.overdueTime;
					this.storeTime = res.storeTime;
					this.takeTime = res.takeTime;
					this.status = res.status;
					this.qrCode = res.barcode.qrcodeCustomerTake
					this.addressMain = res.lockerLocationDetail.location;
					this.addressDetail = res.lockerLocationDetail.address;
					this.addressAdditionalDetail = res.lockerLocationDetail.descriptionBahasa;
					this.operationalHour = res.lockerLocationDetail.operationalHourBahasa;
					this.locker_photo = res.lockerLocationDetail.photo;
					this.mapUrl = res.lockerLocationDetail.mapsLink;
					this.lat = res.lockerLocationDetail?.latitude
					this.long = res.lockerLocationDetail?.longitude
					if(this.language == 'en'){
						this.addressAdditionalDetail = res.lockerLocationDetail?.description || "-";
						this.operationalHour = res.lockerLocationDetail?.operationalHour|| "-";
					}
        })
        .catch((error) => {
					console.log(error)
					this.loadingIcon = false;
          const message = error.response.data.message || i18n.t('something_wrong');
          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: message,
          });
        });
    } else {
			this.loadingIcon = false;
      this.redirectToPaxelbox();
    }
  },
	computed: {
		displayStatus() {
			if (this.status === 'IN_STORE') {
				return {
					text: this.language === 'en' ? 'Package inside The Locker' : 'Paket Di Dalam Loker',
					color: '#FFB003',
				};
			} else if (this.status === 'IMPORTED') {
				return {
					text: this.language === 'en' ? 'To be opened' : 'Menunggu dibuka',
					color: '#56c378',
				};
			} else if (this.status === 'CUSTOMER_TAKEN') {
				return {
					text: this.language === 'en' ? 'Taken By Customer' : 'Sudah Diambil Customer',
					color: '#5e51a1',
				};
			} else if (this.status === 'CANCEL') {
				return {
					text: this.language === 'en' ? 'Cancelled' : 'Dibatalkan',
					color: '#FF434F',
				};
			} else if (this.status === 'TAKEN_BY_SYSTEM') {
				return {
					text: this.language === 'en' ? 'Ended by System' : 'Diakhiri Sistem' ,
					color: '#5e51a1',
				};
			} else if (this.status === 'OPERATOR_TAKEN' || this.status === 'OPERATOR_PICK') {
				return {
					text: this.language === 'en' ? 'Operator Pickup Item(s)' : 'Barang Diambil Operator Paxel' ,
					color: '#5e51a1',
				};
			}else{
				return {
					text: this.status ,
					color: '#5e51a1',
				};
			}
		},
		rentInfo() {
			let defaultData = [
				{
					label: this.language == "en" ? "Items Stored" : "Barang Disimpan",
					key:"storeTime",
					value: this.storeTime,
					isDate:true
				},
				{
					label: this.language == "en" ? "Items Taken" : "Barang Diambil",
					key:"takeTime",
					value: this.takeTime,
					isDate:true
				},
				{
					label: this.language == "en" ? "Order Number" : "Nomor Order",
					key:"orderNumber",
					value: this.orderNumber
				}
			]
			//check status, if instore not needed barang diambil 
			if(this.status == 'IN_STORE'){
				let filteredArray = defaultData.filter(item => item.key !== 'takeTime');
				return filteredArray;
			}else{
				return defaultData;
			}
		},
		paymentInfo() {
			const arr = [
				{
					label: this.language == "en" ? "Rent Fee" : "Biaya Sewa",
					value: this.formatRupiah(this.payOfAmount),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Admin Fee" : "Biaya Admin",
					value: this.formatRupiah(this.adminFee?.total_amount ?? 0),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Total Payment" : "Total Pembayaran",
					value: this.formatRupiah(
						(this.payOfAmount ?? 0) + (this.adminFee?.total_amount ?? 0) + (this.totalDonation ?? 0)
					),
					labelStyle: "font-weight:bold;font-size:14px",
					valueStyle: "font-weight:bold;font-size:16px",
					addBreak: true
				},
				{
					label: this.language == "en" ? "Payment Method" : "Metode Pembayaran",
					value: this.paymentMethod,
					addBreak: true
				}
			];

			if(this.donation){
				const donations = this.donation.map(donate => {
					return {
						label: `${donate.qty} item | ${this.language == "en" ? donate.name.en : donate.name.id}`,
						value: this.formatRupiah(donate.sub_total),
						addBreak: true
					};
				});
	
				arr.splice(1, 0, ...donations);
				return arr;
			}else{
				return arr;
			}
		},
	},
  methods: {
    onHide() {
      if (this.$route.query.preview) {
        this.$router.go(-1);
      }
    },
    show(imageUrl) {
      this.$router.push(`${this.$route.fullPath}&preview=true`);
      this.$viewerApi({
        options: {
          button: false,
          navbar: false,
          title: false,
          toolbar: false,
          tooltip: false,
          movable: false,
          zoomable: true,
          rotatable: false,
          scalable: true,
          transition: true,
          fullscreen: true,
          keyboard: false,
          hidden: (e) => {
            this.onHide(e);
          },
        },
        images: [imageUrl],
      });
    },
    redirectToPaxelbox() {
      this.$router.push({ path: '/' });
    },
		clickContactSupport() {
			if (typeof MobileJS != 'undefined') {
				MobileJS.contactSupport(JSON.stringify({ title: 'Yellow AI' }));
			} else if (typeof webkit != 'undefined') {
				try {
					webkit.messageHandlers.contactSupport.postMessage(JSON.stringify({ title: 'Yellow AI' }));
				} catch (err) {
					console.log('The native context does not exist yet');
				}
			} else {
				window.location.href = this.heraUrl;
			}
		},
		validateUser() {
			let data_payload = {
				"token": this.$route.query.token
			}
			if (this.$route.query.token){
				this.$store.dispatch("validateUser", data_payload)
			}
		},
		openMapLink() {
			this.buttonSyncOpenGmapLocation(this.lat, this.long, this.mapUrl)
		},
		checkIsOverdue(paramOrderId  ,current_time, deadlineDate, overdue_total_price){
			//check overdue only for this two status and if its overdue price is not 0
			if((this.status == "IN_STORE" || this.status == "IMPORTED") && overdue_total_price > 0){
				if (current_time > deadlineDate){
					clearInterval(this.counterCheck);
					this.$router.push(`/overduepayment?orderid=${paramOrderId}`) 
				}
			}
		}
  },
  watch: {
    $route(val) {
      if (!val.query.preview) {
        const viewer = document.getElementsByClassName('viewer-canvas')?.[0];
        if (viewer) {
          viewer.click();
        }
      }
    },
  },
};
</script>

<style>
.order-card {
	border: 1px solid #EBEAF3;
	border-radius: 8px;
	padding: 1px;
}

.order-card-bottom {
	border: 1px solid #EBEAF3;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	padding: 1px;
}

.order-card-top {
	border: 1px solid #EBEAF3;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 1px;
}

.image-fit {
	width: 100%;
	/* or any custom size */
	height: 100%;
	object-fit: fill;
	border-radius: 4px;
}

.status-text-yellow {
	color: #FFB003;
	font-size: 14px;
	font-weight: bold;
	line-height: 18px;
}

.status-text-green {
	color: #29B473;
	font-size: 14px;
	font-weight: bold;
	line-height: 18px;
}

.status-text-purple {
	color: #5F51A1;
	font-size: 14px;
	font-weight: bold;
	line-height: 18px;
}

.btn-primary:hover {
	color: #fff;
	background-color: #5F51A1;
	border-color: #5F51A1;
}</style>
